import React, { useState } from 'react';
import styles from '../styles/Settings.module.css';

const Toast = ({ show, message, type }) => (
  show ? (
    <div className={styles.toast + ' ' + (type === 'success' ? styles.toastSuccess : styles.toastError)}>
      {message}
    </div>
  ) : null
);

const Settings = () => {
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });
  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: '', type: 'success' }), 2200);
  };

  return (
    <div className={styles.settingsContainer}>
      {/* <h2 className={styles.pageTitle}>App Settings</h2> */}
      <Toast show={toast.show} message={toast.message} type={toast.type} />
    </div>
  );
};

export default Settings;